import styled from 'styled-components';

export interface IContainer {
  marginLeft?: string;
  color?: string;
  bkcolor?: string;
  nopadding?: boolean;
  textAlign?: string;
}

export const Container = styled.span<IContainer>`
  padding: 0px;
  font-size: 1em;
  margin-left: ${props => props.marginLeft || '0px'};
  font-weight: bold;
  background-color: ${props => props.bkcolor || '#000'};
  color: ${props => props.color || '#000'};
  padding: ${props => props.nopadding ? '0px' : '4px 6px'};
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  text-align: ${props => props.textAlign || 'left'};
`